import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqItems } from "@/mocks/digData";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0]?.id ?? null);

  return (
    <section id="faq" className="scroll-mt-24 py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-8">
        <SectionHeading
          align="center"
          eyebrow="FAQ"
          title="关于追踪与更新的常见问题"
          desc="我们怎么更新、怎么处理反转与更正、爆料能否投稿——先看这里，少走弯路。"
        />

        <div className="mt-10 md:mt-14 flex flex-col gap-3 md:gap-4">
          {faqItems.map((item, index) => {
            const open = openId === item.id;
            return (
              <article
                key={item.id}
                className={`rounded-lg border bg-background-100 overflow-hidden transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <h4 className="m-0">
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenId(open ? null : item.id)}
                    className="w-full flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                  >
                    <span className="shrink-0 font-label text-primary-500 text-lg md:text-xl">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-700">
                      <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                </h4>
                {open && (
                  <div className="px-4 md:px-6 pb-4 md:pb-5 pl-12 md:pl-16">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}